module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "assembly move"
  }, [_c('img', {
    staticClass: "as_hea",
    attrs: {
      "src": "https://s10.mogucdn.com/mlcdn/c45406/170523_3588j3005fhc2d8f1icgijbgg23gk_740x128.jpg_750x999.v1c7E.70.webp"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "assembly1"
  }, [_c('img', {
    staticClass: "big_img",
    attrs: {
      "src": _vm.well1Img
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fmove"
  }, [_c('ul', {
    directives: [{
      name: "shift",
      rawName: "v-shift"
    }],
    staticClass: "bomove clearfix"
  }, _vm._l((_vm.aswell1), function(a1) {
    return _c('li', [_c('a', {
      attrs: {
        "href": '#/detail/' + a1.signGoodsId
      }
    }, [_c('img', {
      attrs: {
        "src": a1.image
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "astitle"
    }, [_vm._v(_vm._s(a1.title))]), _vm._v(" "), _c('p', {
      staticClass: "mo_price"
    }, [_vm._v(_vm._s(a1.price))])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "assembly2"
  }, [_c('img', {
    staticClass: "big_img",
    attrs: {
      "src": _vm.well2Img
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fmove"
  }, [_c('ul', {
    directives: [{
      name: "shift",
      rawName: "v-shift"
    }],
    staticClass: "bomove clearfix"
  }, _vm._l((_vm.aswell2), function(a2) {
    return _c('li', [_c('a', {
      attrs: {
        "href": '#/detail/' + a2.signGoodsId
      }
    }, [_c('img', {
      attrs: {
        "src": a2.image
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "astitle"
    }, [_vm._v(_vm._s(a2.title))]), _vm._v(" "), _c('p', {
      staticClass: "mo_price"
    }, [_vm._v(_vm._s(a2.price))])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "assembly3"
  }, [_c('img', {
    staticClass: "big_img",
    attrs: {
      "src": _vm.well3Img
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fmove"
  }, [_c('ul', {
    directives: [{
      name: "shift",
      rawName: "v-shift"
    }],
    staticClass: "bomove clearfix"
  }, _vm._l((_vm.aswell3), function(a3) {
    return _c('li', [_c('a', {
      attrs: {
        "href": '#/detail/' + a3.signGoodsId
      }
    }, [_c('img', {
      attrs: {
        "src": a3.image
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "astitle"
    }, [_vm._v(_vm._s(a3.title))]), _vm._v(" "), _c('p', {
      staticClass: "mo_price"
    }, [_vm._v(_vm._s(a3.price))])])])
  }))])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "asmore"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("加载更多 ＞")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6687cecb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-6687cecb","hasScoped":true}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./app/component/passembly.vue
// module id = 133
// module chunks = 0